module.exports = __webpack_public_path__ + "media/images/shared/icon_facebook-1f56953d0e86793bf7d91bcc0d0669f4.png";